import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=6774d7dc&lang=css"

const __exports__ = script;

export default __exports__